<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="error">
          <h2>404 Not Found</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped>
html {
  height: 100%;
}

body {
  font-family: 'Lato', sans-serif;
  color: #888;
  margin: 0;
}

.error {
  text-align: center;
}
</style>
